import React from "react";

const sharedRequestTypes = {
  repair: "repair",
  clean: "clean",
  paint: "paint",
  signs: "signs",
  construction: "construction",
  event: "event",
  furniture: "furniture",
  hvac: "hvac",
  moving: "moving",
  access: "access",
  other: "other"
};

// Building up options elements from the JSON data in the arrays defined below
// so we can just import the options elements in the form where we need them
const requestTypes = [
  {
    displayName: "Choose one",
    short: undefined
  },
  {
    displayName: "Repair",
    short: sharedRequestTypes.repair
  },
  {
    displayName: "Clean-up",
    short: sharedRequestTypes.clean
  },
  {
    displayName: "Painting",
    short: sharedRequestTypes.paint
  },
  {
    displayName: "Signs/Wall Graphics",
    short: sharedRequestTypes.signs
  },
  {
    displayName: "Construction",
    short: sharedRequestTypes.construction
  },
  {
    displayName: "Event Setup",
    short: sharedRequestTypes.event
  },
  {
    displayName: "Furniture",
    short: sharedRequestTypes.furniture
  },
  {
    displayName: "Heating/Cooling",
    short: sharedRequestTypes.hvac
  },
  {
    displayName: "Moving/Relocation",
    short: sharedRequestTypes.moving
  },
  {
    displayName: "Access (Keys/Cards)",
    short: sharedRequestTypes.access
  },
  {
    displayName: "Other",
    short: sharedRequestTypes.other
  }
];

const sharedFacilities = {
  atc: "atc",
  blac: "blac",
  neyland: "neyland",
  ntsc: "ntsc",
  pratt: "pratt",
  tba: "tba",
  cronan: "cronan",
  lns: "lns",
  regal: "regal",
  spls: "spls",
  barks: "barks",
  gtc: "gtc",
  dgf: "dgf",
  ajac: "ajac",
  tbt: "tbt",
  warehouse: "warehouse",
  boathouse: "boathouse",
  thornton: "thornton"
};

const facilities = [
  {
    displayName: "Choose one",
    short: undefined
  },
  {
    displayName: "Anderson Training Center",
    short: sharedFacilities.atc
  },
  {
    displayName: "Brenda Lawson",
    short: sharedFacilities.blac
  },
  {
    displayName: "Neyland Stadium",
    short: sharedFacilities.neyland
  },
  {
    displayName: "Neyland Thompson Sports Center",
    short: sharedFacilities.ntsc
  },
  {
    displayName: "Pratt Pavilion",
    short: sharedFacilities.pratt
  },
  {
    displayName: "Thompson-Boling Arena",
    short: sharedFacilities.tba
  },
  {
    displayName: "Thornton Center",
    short: sharedFacilities.thornton
  },
  {
    displayName: "Cronan Volleyball Center",
    short: sharedFacilities.cronan
  },
  {
    displayName: "Lindsey Nelson Stadium",
    short: sharedFacilities.lns
  },
  {
    displayName: "Regal Soccer Stadium",
    short: sharedFacilities.regal
  },
  {
    displayName: "Sherri Parker Lee Stadium",
    short: sharedFacilities.spls
  },
  {
    displayName: "Barskdale Stadium",
    short: sharedFacilities.barks
  },
  {
    displayName: "Goodfriend Tennis Center",
    short: sharedFacilities.gtc
  },
  {
    displayName: "Day Golf Facility",
    short: sharedFacilities.dgf
  },
  {
    displayName: "Jones Aquatic Center",
    short: sharedFacilities.ajac
  },
  {
    displayName: "Tom Black Track",
    short: sharedFacilities.tbt
  },
  {
    displayName: "Track Warehouse",
    short: sharedFacilities.warehouse
  },
  {
    displayName: "Basler Boathouse",
    short: sharedFacilities.boathouse
  }
];

const requestTypeOptions = requestTypes.map(createOptionElement);
const facilityOptions = facilities.map(createOptionElement);

// Create an option element from an array of values
function createOptionElement(type, index) {
  if (index > 0) {
    return (
      <option key={index} value={type.short}>{`${type.displayName}`}</option>
    );
  }

  // Setting a disabled option as an instructional piece
  return (
    <option disabled defaultValue key={index} value="none">{`${
      type.displayName
    }`}</option>
  );
}

export { facilityOptions, requestTypeOptions };



// WEBPACK FOOTER //
// ./src/Facilities/config/formOptionElements.js